'use client';

export { getQueryClient } from './browser-query-client';
